export const pagination = {
  page: 1,
  per_page: 30,
  total: 30,
};
